import axios from "axios";
import { ICustomDictionaryModel } from "../../store/customDictionariesStore";

export default {
  getCustomDictionariesGroupped() {
    return axios.get(`/nsi/Dictionary/Groupped`, {});
  },
  createDictionary(model: ICustomDictionaryModel) {
    return axios.post(`/nsi/Dictionary`, model);
  },
  addDictionaryToGroup(groupName, dictionaryName) {
    return axios.post(`/nsi/Dictionary/Group/${groupName}/${dictionaryName}`, {});
  },
  getCustomDictionaryItems(dictionaryName) {
    return axios.get(`/nsi/Dictionary/${dictionaryName}/Items`, {});
  },
  updateCustomDictionaryItems(model) {
    return axios.put(`/nsi/Dictionary/Items`, model);
  },

  createCustomDictionaryItems(model) {
    return axios.post(`/nsi/Dictionary/Items`, model);
  },

  getCustomDictionaryByName(dictionaryName) {
    return axios.get(`/nsi/Dictionary/${dictionaryName}`);
  },
  getAllItemsVersions(dictionaryName) {
    return axios.get(`/nsi/Dictionary/Version/${dictionaryName}`);
  },
  async getDictionaryGroupsTree(
    currentPage: number | string,
    countPerPage: number | string,
    searchValue: string,
  ) {
    return await axios.post(`/nsi/Dictionary/Tree`, {
      page: currentPage,
      count: countPerPage,
      search: {
        text: searchValue,
        allTextFields: true,
      },
    });
  },
};
